import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';
import { field } from '../Input/style/default';

const { color } = theme;

const wrap: CSSObject = {
  ...field,
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  width: 280,
  maxWidth: '100%',
  height: 40,
  padding: '0 12px',
  gap: 8,
  cursor: 'text',
  ':focus-within': {
    borderColor: color.primary,
    boxShadow: `0 0 0 3px ${color.grey75}`,
  },
  [mobile]: {
    width: '100%',
  },
};

const icon: CSSObject = {
  flex: 'none',
  color: color.grey400,
};

const input: CSSObject = {
  flex: 1,
  minWidth: 0,
  height: '100%',
  padding: 0,
  border: 'none',
  outline: 'none',
  background: 'transparent',
  fontSize: 14,
  color: color.text,
  '::placeholder': {
    color: color.grey300,
  },
  '::-webkit-search-cancel-button': {
    cursor: 'pointer',
  },
};

export { wrap, icon, input };
